import smoothscroll from 'smoothscroll-polyfill';

export default () => smoothscroll.polyfill();

const Direction = Object.freeze({
    UP: 1,
    DOWN: 2
});

export const scrollIntoView = (target, offset = {scrollUp: 0, scrollDown: 0}) => {

    if (typeof target === 'undefined') return;

    const targetOffset = getElementOffset(target);
    const scrollDirectionOffset = getScrollDirection(targetOffset) === Direction.DOWN ? offset.scrollDown : offset.scrollUp;

    window.scroll({
        top: targetOffset - scrollDirectionOffset,
        left: 0,
        behavior: 'smooth'
    });

};

export const getElementOffset = (el) => {
    const rect = el.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return  Math.round(rect.top + scrollTop);
};

export const getDocumentOffset = () =>
    window.pageYOffset !== undefined
        ? Math.round(window.pageYOffset)
        : Math.round(
              (
                  document.documentElement ||
                  <Element>document.body.parentNode ||
                  document.body
              ).scrollTop
          ); 

export const getScrollDirection = (targetOffset) => getDocumentOffset() > targetOffset ? Direction.UP : Direction.DOWN; 